import { ITableButtonProps } from '@components/common/UTable/UTable';

import { farm } from '@/shared/security/permissions/farm';

import { FarmFilterUpdate } from '../../types';
interface ExtraButtonConfigProps {
  disabledClearBtn: boolean;
  onFarmUpdate: (filters: FarmFilterUpdate) => void;
  onOpenModal: () => void;
  isLoading: boolean;
}

export const extraButtonConfig = ({
  disabledClearBtn,
  onFarmUpdate,
  onOpenModal,
  isLoading,
}: ExtraButtonConfigProps): ITableButtonProps[] => {
  return [
    {
      text: 'Добавить ряд',
      type: 'primary',
      action: () => {
        onFarmUpdate({ isAddColumn: true });
      },
      disabled: isLoading,
      security: { permissions: farm.editScheme },
    },
    {
      text: 'Добавить ряд ячеек',
      type: 'primary',
      action: () => {
        onFarmUpdate({ isAddRow: true });
      },
      disabled: isLoading,
      security: { permissions: farm.editScheme },
    },
    {
      text: 'Очистить объект',
      type: 'primary',
      action: () => onOpenModal(),
      disabled: isLoading || disabledClearBtn,
      security: { permissions: farm.cleanFacility },
    },
  ];
};
